import { render, staticRenderFns } from "./PurchaseRequisitionApprove.vue?vue&type=template&id=0eb6a8d9&"
import script from "./PurchaseRequisitionApprove.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequisitionApprove.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequisitionApprove.vue?vue&type=style&index=0&id=0eb6a8d9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports